import {
  Component,
  Input
} from '@angular/core';

import {
  CommonModule
} from '@angular/common';

@Component({
  selector: 'app-tax-breakdown-drawer',
  standalone: true,
  imports: [
    CommonModule
  ],
  templateUrl:'./tax-breakdown-drawer.component.html'
})
export class TaxBreakdownDrawerComponent {

  @Input()
  lines: any[] = [];

  @Input()
  summary: any = {};

  get transactionTaxSummary(): any[] {

    const map =
      new Map<string, any>();

    this.lines.forEach(line => {

      (
        line.tax_lines ||
        line.taxLines ||
        []
      ).forEach((tax: any) => {

        const code =
          tax.taxCode ||
          tax.tax_code;

        if (!map.has(code)) {

          map.set(code, {

            taxCode: code,

            taxName:
              tax.taxName ||
              tax.tax_name,

            rate:
              tax.taxRate ||
              tax.rate,

            amount: 0
          });
        }

        map.get(code).amount +=
          Number(
            tax.taxAmount ??
            tax.tax_amount ??
            0
          );

      });

    });

    return Array.from(
      map.values()
    );
  }

  get totalTax(): number {

    return this.transactionTaxSummary
      .reduce(

        (t, x) =>
          t + Number(x.amount),

        0
      );
  }
}